// extracted by mini-css-extract-plugin
export default {"hero":"ServicesHero_hero__hSpBv","container":"ServicesHero_container__JYSLM","title":"ServicesHero_title__+JFrq","description":"ServicesHero_description__pjY39"};